/**
 * SS-4428 — the PMS a customers-page row shows, read-only.
 *
 * `pms` is the display name of the business's active adapter, as GET /locations answers
 * with it (absent when the business has no adapter). A parent row shows its own; a parent
 * with none shows the distinct PMSs of its locations ("Dentrix, Eaglesoft"), and nothing
 * when none of them has one either.
 */
export const customerPms = (customer) => {
  if (customer?.pms) return customer.pms;
  const names = (customer?.locations || []).map((location) => location?.pms).filter(Boolean);
  return [...new Set(names)].sort().join(", ");
};
